export const SET_BREADCRUMB_LIST = "SET_BREADCRUMB_LIST";

export const setBreadcrumbList = list => dispatch => {
  dispatch({ type: SET_BREADCRUMB_LIST, payload: list });
};
